import*as e from"react";import{I as r}from"./index-bbf0f73e.js";const t=(t,l)=>e.createElement(r,l,e.createElement("path",{fill:"currentColor",d:t,fillRule:"evenodd",clipRule:"evenodd"}));export{t as c};
//# sourceMappingURL=createSvgIcon-5dd11a01.js.map
